import Panel from "../../Common/Panel";
import { addThermoFunc, addSpot } from "./helper";
import store from "../../Common/Store";
import { heatAreaEvent } from "../global_helper";
import { useEffect, useState } from "react";
import ThermostatWarning from "../../Common/ThermostatWarning";

const PanelWrapped = (
  stateStep,
  stateCanva,
  setStateHeatArea,
  statePoly,
  stateAccess,
  setHeatAreaLoad
) => {
  const [thermoAlert, setThermoAlert] = useState(0);
  const [thermoWarningVisible, setThermoWarningVisible] = useState(false);
  const url_string = window.location.href;
  const url = new URL(url_string);
  const c = url.searchParams.get("thermo");
  const thermo = parseInt(c);

  if (!thermo) {
    return (
      <Panel
        page={stateStep === 1 ? 2 : 3}
        cold={stateStep === 2 ? true : false}
        spotFunc={(a, b, c) => {
          if (store.polygon) {
            store.spots.push(
              addSpot(
                a,
                b,
                c,
                store.polygon.points[0].x + 1,
                store.polygon.points[0].y + 1,
                stateCanva,
                stateAccess
              )
            );
            setHeatAreaLoad(1);
            heatAreaEvent(stateCanva, setHeatAreaLoad, setStateHeatArea);
          }
        }}
        clearSpotFunc={() => {
          stateCanva?.stage.find(".cold_spot").forEach((spot) => spot.destroy());
          stateCanva?.stage.find(".x_point").forEach((point) => {
            if (point.getAttr("parent_shape")?.getName() === "cold_spot") {
              point.getAttr("parent_group")?.destroy();
            }
          });
          store.spots = [];
          setHeatAreaLoad(1);
          heatAreaEvent(stateCanva, setHeatAreaLoad, setStateHeatArea);
        }}
      />
    );
  } else {
    return (
      <>
        <Panel
          page="5"
          addThermo={(id, obj) => {
          if (thermoAlert === 0) {
            if (store.spots) {
              if (store.spots.length > 0) {
                setThermoWarningVisible(true);
              }
            }
          }

          setThermoAlert(1);
          store.thermo = [];
          stateCanva.stage.find(".thermo").forEach((elm) => {
            elm.destroy();
          });
          store.thermo.push(addThermoFunc(stateCanva, statePoly, id));
          store.thermoInfo = obj;
          return store.thermo;
          }}
        />
        {thermoWarningVisible && (
          <ThermostatWarning
            onClose={() => setThermoWarningVisible(false)}
          />
        )}
      </>
    );
  }
};

export default PanelWrapped;
